// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default {
  campaignId: __t.u64(),
  target: __t.string(),
  life: __t.u32(),
  mount: __t.string(),
  seq: __t.u64(),
  ageMs: __t.u32(),
  ox: __t.f64(),
  oy: __t.f64(),
  oz: __t.f64(),
  ix: __t.f64(),
  iy: __t.f64(),
  iz: __t.f64(),
  version: __t.u32(),
};
